// extracted by mini-css-extract-plugin
module.exports = {"turn-down":"turn-down-c2c0069c4fbc69f1462d25642a0287cc","reject-message":"reject-message-cfb1cf1226bd6603e18fd09e435661da"};